export default "__VITE_ASSET__BTUoGvv7__"